import styled from 'styled-components';

const Content = styled.div`
  position: relative;
  width: 100%;
  max-width: 45%;
  padding: 0 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .crew-button {
    margin-top: 1em;
  }
  @media screen and (max-width: 1725px) {
    max-width: 30em;
  }
`;

export default Content;
